import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { formatValue } from "../../../utilities";
import { orderByValues } from "../../../data/data";
import styleConstants from "../../../styleConstants";
import StackedColumnChart from "../../chart/StackedColumnChart";

const ShareOfUsersVsCostChart = props => {
  const data = props.data;

  const gniGroups = ["LIC", "L-MIC", "U-MIC"];

  return (
    <div>
      <StackedColumnChart
        ref={props.innerRef}
        height={styleConstants.stackedBarHeight}
        categories={["User", "Cost"]}
        series={gniGroups.map(gniGroup => ({
          name: gniGroup,
          color: styleConstants.categoryColors.gniGroupColors[gniGroup],
          data: orderByValues(
            data.filter(datum => datum.area === gniGroup),
            gniGroups,
            "area"
          ).map(datum => datum.value)
        }))}
        reversedLegend={true}
        tooltipFormatter={function() {
          return `${this.series.name} Share of ${
            this.key
          } Mix: <strong>${formatValue(
            Math.abs(this.percentage) / 100,
            true
          )}</strong>`;
        }}
      />
    </div>
  );
};

ShareOfUsersVsCostChart.propTypes = {
  data: PropTypes.array.isRequired
};

export default memo(
  React.forwardRef((props, ref) => (
    <ShareOfUsersVsCostChart innerRef={ref} {...props} />
  ))
);
